<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="pa-0">
          <v-title>Update Wholesaler Detail</v-title>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 sm6 class="px-2">
                  <v-text-field
                    v-model="editedItem.custNo"
                    label="Customer Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="px-2">
                  <ValidationProvider
                    name="Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <ValidationProvider
                    name="Output File Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedItem.outputFileName"
                      label="Output File Name"
                      name="Output File Name"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                    v-model="editedItem.email"
                    label="Contact Email"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                    v-model="editedItem.bcc"
                    label="Bcc Email"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                    v-model="editedItem.custPlanNo"
                    label="Cust Plan No"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-checkbox
                    v-model="editedItem.summaryNotification"
                    label="Send summary Notification"
                    required
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-checkbox
                    v-model="editedItem.sellService"
                    label="Sell Service"
                  ></v-checkbox>
                </v-flex>
                <v-flex v-if="allFlags.SOG3531" xs12 class="px-2">
                  <v-checkbox
                    v-model="editedItem.sellPBXService"
                    label="Sell PBX Service"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!valid" class="primary" @click="submit">
            Submit
          </v-btn>
          <v-btn color="light-grey" @click="close()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :total-items="totalItems"
      :pagination.sync="pagination"
      :items="filteredRows"
      :headers="headers"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="(prop, propIndex) in headers.filter(
            (x) => x.text != 'Actions'
          )"
          :key="propIndex"
          :class="'ma-0'"
        >
          <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
            {{ props.item[prop.value][prop.nested] }}
          </div>

          <div v-else :class="'text-xs-' + prop.align">
            {{ props.item[prop.value] }}
          </div>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-flex sm12 md12 lg12>
      <message-alert :component="message"></message-alert>
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapWholesalerDetailFields,
  mapWholesalerDetailMultiRowFields,
} from '@/store/modules/orders';

const {
  mapActions: mapWholesalerDetailActions,
  mapMutations: mapWholesalerDetailMutations,
} = createNamespacedHelpers(`orders/wholesalerDetail`);
import { httpError } from '@/models/httpError';
import { WholesalerDetail } from '@/models/WholesalerDetail';

export default {
  name: 'maintainWholesalerDetail',
  data: () => ({
    valid: true,
    dialog: false,
    editedItem: new WholesalerDetail(),
    editedIndex: 0,
    SearchText: null,
    items: [],
    totalItems: 0,
    updateEmail: null,
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,
    headers: [
      {
        text: 'Id',
        align: 'right',
        sortable: true,
        value: 'id',
      },
      {
        text: 'Customer Number',
        sortable: true,
        value: 'custNo',
      },
      {
        text: 'Name',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Output File Name',
        sortable: true,
        value: 'outputFileName',
      },
      {
        text: 'Contact Email',
        width: '20vw',
        sortable: true,
        value: 'email',
      },
      {
        text: 'Cust PlanNo',
        sortable: true,
        value: 'custPlanNo',
      },

      {
        text: 'Actions',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapWholesalerDetailFields(['message']),
    ...mapWholesalerDetailMultiRowFields(['rows']),

    filteredRows: function () {
      let result = this.items.filter(this.isValid);
      return result;
      // let vm = this;
      // if (vm.SearchText === null || vm.SearchText.toString().length == 0) return vm.getters.getCustomerDetailsArray();
      // return vm.getters.getCustomerDetailsArray.filter(x=> x.customerNumber == vm.SearchText);
    },
  },

  methods: {
    ...mapWholesalerDetailActions([
      'getWholesalerDetails',
      'updateWholesaler',
      'setMessage',
    ]),
    ...mapWholesalerDetailMutations(['addRow']),
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        vm.getWholesalerDetails().then((data) => {
          let items = data.data;
          const total = data.count;
          vm.loading = false;
          resolve({
            items,
            total,
          });
        });
      });
    },

    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, this.items[this.editedIndex]);
      this.dialog = true;
    },

    isValid: function (item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter((x) => x.sortable).map((x) => x.value);
      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },
    submit() {
      let vm = this;
      vm.updateWholesaler(vm.editedItem)
        .then((data) => {
          vm.getWholesalerDetails().then((data) => {
            vm.items = data.data;
            vm.total = data.data.length;
            vm.loading = false;
          });
        })
        .catch((err) => {});
      this.dialog = false;
    },

    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
      this.dialog = false;
    },

    save() {
      // let vm = this;
      // vm.saveResourceFile(vm.editedIndex)
      //     .then(() => this.close())
      //     .catch(() => this.close());
    },
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.setMessage(new httpError());
      vm.getWholesalerDetails()
        .then((data) => {
          vm.items = data.data;
          vm.total = data.data.length;
          vm.loading = false;
        })
        .catch(() => {});
    });
  },
};
</script>
